// frontend/src/components/HistoryPanel.jsx
import { useState, useEffect } from 'react';
import api from '../services/api';

export default function HistoryPanel() {
    const [historyData, setHistoryData] = useState({ total: 0, grouped: {} });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchHistory();
        const interval = setInterval(fetchHistory, 60000); // Atualizar a cada 60s
        return () => clearInterval(interval);
    }, []);

    const fetchHistory = async () => {
        try {
            const response = await api.get('/service-alerts/history/today');
            setHistoryData(response.data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching history:', error);
            setLoading(false);
        }
    };

    // Função para formatar data UTC do banco para horário local
    const formatTime = (dateString) => {
        if (!dateString) return '--:--';
        try {
            // Garantir que a data seja interpretada como UTC
            const date = new Date(dateString);
            return date.toLocaleTimeString('pt-BR', {
                timeZone: 'America/Sao_Paulo',
                hour: '2-digit',
                minute: '2-digit'
            });
        } catch (e) {
            return '--:--';
        }
    };

    const getServiceLabel = (serviceType) => {
        const labels = {
            housekeeper: 'Governanta',
            cleaning: 'Higienização',
            laundry: 'Lavanderia',
            maintenance: 'Manutenção',
            nursing: 'Enfermagem'
        };
        return labels[serviceType] || serviceType;
    };

    const getServiceIcon = (serviceType) => {
        const icons = {
            housekeeper: 'bi-person-check',
            cleaning: 'bi-droplet',
            laundry: 'bi-basket',
            maintenance: 'bi-tools',
            nursing: 'bi-heart-pulse'
        };
        return icons[serviceType] || 'bi-bell';
    };

    const getServiceColor = (serviceType) => {
        const colors = {
            housekeeper: 'primary',
            cleaning: 'success',
            laundry: 'info',
            maintenance: 'warning',
            nursing: 'danger'
        };
        return colors[serviceType] || 'secondary';
    };

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center h-100">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Carregando...</span>
                </div>
            </div>
        );
    }

    return (
        <div className="h-100 d-flex flex-column">
            <div className="p-3 bg-light border-bottom sticky-top">
                <h5 className="mb-0">
                    <i className="bi bi-clock-history me-2"></i>
                    Histórico do Dia
                </h5>
                <small className="text-muted">Total: {historyData.total} serviço(s) concluído(s)</small>
            </div>

            <div className="flex-grow-1 overflow-auto p-3">
                {historyData.total === 0 ? (
                    <div className="alert alert-info">
                        <i className="bi bi-info-circle me-2"></i>
                        Nenhum serviço concluído hoje ainda.
                    </div>
                ) : (
                    Object.entries(historyData.grouped).map(([serviceType, items]) => (
                        <div key={serviceType} className="mb-4">
                            <div className={`d-flex align-items-center mb-2 p-2 bg-${getServiceColor(serviceType)} bg-opacity-10 rounded`}>
                                <i className={`bi ${getServiceIcon(serviceType)} me-2 text-${getServiceColor(serviceType)}`}></i>
                                <strong className={`text-${getServiceColor(serviceType)}`}>
                                    {getServiceLabel(serviceType)}
                                </strong>
                                <span className="ms-auto badge bg-secondary">{items.length}</span>
                            </div>

                            <div className="list-group mb-3">
                                {items.map((item) => (
                                    <div key={item.id} className="list-group-item list-group-item-action p-2">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="flex-grow-1">
                                                <div className="fw-bold mb-1">{item.bed_number}</div>
                                                <div className="d-flex gap-3 flex-wrap">
                                                    <small className="text-muted">
                                                        <i className="bi bi-bell me-1"></i>
                                                        {formatTime(item.created_at)}
                                                    </small>
                                                    <small className="text-success">
                                                        <i className="bi bi-check-circle me-1"></i>
                                                        {formatTime(item.completed_at)}
                                                    </small>
                                                    {item.completed_by_name && (
                                                        <small className="text-muted">
                                                            <i className="bi bi-person me-1"></i>
                                                            {item.completed_by_name}
                                                        </small>
                                                    )}
                                                </div>
                                            </div>
                                            <span className={`badge bg-${getServiceColor(serviceType)} ms-2`}>
                                                <i className="bi bi-check"></i>
                                            </span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}
